import { render, staticRenderFns } from "./BaseLoadingPage.vue?vue&type=template&id=6ced999c&scoped=true"
import script from "./BaseLoadingPage.vue?vue&type=script&lang=js"
export * from "./BaseLoadingPage.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingPage.vue?vue&type=style&index=0&id=6ced999c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ced999c",
  null
  
)

export default component.exports